import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../common/common.css';
import NewPasswordInput from '../new-password-input/new-password-input';
import Loading from '../loading/loading'; // Adjust the import based on your project structure

function ConfirmPasswordReset() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_FACES_API_BASE}/password/confirm`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            code: confirmationCode,
            new_password: newPassword,
          }),
        }
      );

      if (response.ok) {
        window.alert('Your password has been reset successfully.');
        navigate('/login');
      } else {
        const errorData = await response.json();
        window.alert(errorData.message);
      }
    } catch (error) {
      console.error('Error during password reset confirmation:', error);
      window.alert('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <form onSubmit={handleSubmit} id="main-form" autoComplete="off">
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Confirmation Code"
        value={confirmationCode}
        onChange={(e) => setConfirmationCode(e.target.value)}
        required
      />
      <NewPasswordInput
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        showPassword={showNewPassword}
        setShowPassword={setShowNewPassword}
      />
    </form>
  );
}

export default ConfirmPasswordReset;
